import { QueryClient } from "@tanstack/react-query";
import Bugsnag from "~/lib/Bugsnag";
import { Build } from "~/components/build/Show/lib/types";
import { AnnotationScope } from "~/components/build/Show/lib/types/Annotation";
import { allBuildAnnotationsQueryKey } from "~/components/build/Show/lib/queries/allBuildAnnotations";
import { allJobAnnotationsQueryKey } from "~/components/build/Show/lib/queries/allJobAnnotations";
import { ALL_ANNOTATIONS_QUERY_KEY_PREFIX } from "~/components/build/Show/lib/queries/allAnnotations";
import { jobAnnotationsQueryKey } from "~/components/build/Show/lib/queries/jobAnnotations";
import { jobQueryKey } from "~/components/build/Show/lib/queries/job";

export function annotationsChangedHandler(
  queryClient: QueryClient,
  buildId: Build["id"],
  scope: AnnotationScope,
  jobUuid?: string,
): void {
  // The AnnotationsPanel's combined-list query has variants for "any" / "build" / "job"
  // scopes; invalidate them all in one go via prefix match whenever any annotation changes.
  queryClient.invalidateQueries({
    queryKey: ["build", buildId, "annotations", ALL_ANNOTATIONS_QUERY_KEY_PREFIX],
    exact: false,
  });

  switch (scope) {
    case "build":
      queryClient.invalidateQueries({
        queryKey: allBuildAnnotationsQueryKey(buildId),
        exact: true,
      });
      break;
    case "job":
      queryClient.invalidateQueries({
        queryKey: allJobAnnotationsQueryKey(buildId),
        exact: true,
      });
      if (jobUuid) {
        queryClient.invalidateQueries({
          queryKey: jobAnnotationsQueryKey(buildId, jobUuid),
          exact: true,
        });
        // We invalidate the job here to correctly render the annotationCountsByStyle
        queryClient.invalidateQueries({
          queryKey: jobQueryKey(buildId, jobUuid),
          exact: true,
        });

        // Invalidate all step queries (batch + individual) so the list view
        // badge and step drawer refresh annotation counts.
        queryClient.invalidateQueries({
          queryKey: ["build", buildId, "steps"],
          exact: false,
        });
      }
      break;
    default:
      Bugsnag.notify(`[annotationsChangedHandler] Unknown annotation scope: ${scope}`);
      break;
  }
}
